import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { EapAllRequestsViewModalComponent } from './eap-all-requests-view-modal/eap-all-requests-view-modal.component';
import { EapReturnRetrivalModalComponent } from './eap-return-retrival-modal/eap-return-retrival-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-eap-all-requests',
  templateUrl: './eap-all-requests.component.html',
  styleUrls: ['./eap-all-requests.component.scss']
})
export class EapAllRequestsComponent implements OnInit {
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  productlist: any = [];
  statuslist: any = [];
  AllRequestSearch: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  IsPatientsAvailable = "yes";

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.permission = "";
    if (this.commonService.getPagePermission("EAP06") != null && this.commonService.getPagePermission("EAP06") != undefined) {
      //debugger
      this.permission = this.commonService.getPagePermission("EAP06").toLowerCase();
    }
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      this.commonService.ValidationBanner("Please save the first form of the application, before navigating to the other forms.");
    //  this.commonService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Please save the first form of the application, before navigating to the other forms." } } });
      return false;
    }

    this.userType = this.userService.getUserType();
    //debugger;
    this.AllRequestSearch = new UntypedFormGroup({
      RequestID: new UntypedFormControl(null),
      ProductName: new UntypedFormControl(null),
      RequestType: new UntypedFormControl(null),
      Status: new UntypedFormControl(0),
    });
    this.productlist = [];

    this.statuslist = [
     { "value": "1", "label": "Draft" },
    { "value": "3", "label": "Approved" },
    { "value": "4", "label": "Rejected" },
    { "value": "6", "label": "Allocated" },
    { "value": "8", "label": "Withdraw" },
    { "value": "7", "label": "Closed" }
    ];




    this.columnDefs = [
      {
        "headerName": "Request ID",
        "field": "RequestID"
      },
      {
        "headerName": "Request Type",
        "field": "RequestType"
      },
      {
        "headerName": "Product Name",
        "field": "ProductName",
        "sort": "asc"
      },
      {
        "headerName": "Requested",
        "field": "Requested"
      },
      {
        "headerName": "Allocated",
        "field": "Allocated"
      },
      {
        "headerName": "Used",
        "field": "Used"
      },
      {
        "headerName": "Status",
        "field": "StatusStr"
      }
    ];

    this.tempoperations = [

      {
        "name": "View",
        "id": "view"
      }

    ];

    if (this.permission == "edit") {
      this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });

    }

    if (this.userType == "E") {
      this.tempoperations.push({
        "name": "Return",
        "id": "returnrequest"
      });
      this.tempoperations.push({
        "name": "Withdraw",
        "id": "withdraw"
      });

    }
    else {
   if(this.permission!='view'){

       this.tempoperations.push({
            "name": "Allocate",
            "id": "allocate"
          });
      this.tempoperations.push({
        "name": "Approve",
        "id": "approve"
      });
      this.tempoperations.push({
        "name": "Reject",
        "id": "reject"
      });
      this.tempoperations.push({
        "name": "Retrieve",
        "id": "retrieve"
      });
      this.tempoperations.push({
        "name": "Close",
        "id": "close"
      });
    }
 }

    this.advanceSearch = {

    };

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });


    this.getMasterData();
    this.getSummary();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.modalService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {

      let modalRef = this.modalService.open(EapAllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg modal-full-height modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'View',
        content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
      }
      //modalRef.content.action.subscribe(result => {
      //  this['self'].getSummary();
      //})
  }

  add_product_request() {
      let modalRef = this.modalService.open(EapAllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg modal-full-height modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'Add',
        content: { id: "", ApplicationID: this.ApplicationID }
      }
      modalRef.result.then(result => {
        this.getSummary();
      })

  }

  edit(summay, modalserive) {
    //debugger;
      let modalRef = this['self'].modalService.show(EapAllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        ignoreBackdropClick: true,
        class: 'modal-vlg modal-full-height modal-right',
        animated: true,
        data: {
          heading: 'Edit',
          content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
        }
      });
      modalRef.content.action.subscribe(result => {
        this['self'].getSummary();
      })

  }

  getMasterData() {
    this.summaryService.getSummaryData("api/EAPAllRequests/GetSummaryMaster?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.productlist = summary["MasterData1"];

      //debugger;
      if (summary["MasterData3"] != null && summary["MasterData3"] != undefined) {
        this.IsPatientsAvailable = summary["MasterData3"][0].value;
      }
      if (this.permission == "new") {
        //debugger;

        this.tempoperations.push({
          "name": "Edit",
          "id": "edit"
        });
        this.tempoperations.push({
          "name": "Delete",
          "id": "delete"
        });
      }
      this.operations = this.tempoperations.map(operation => {
        return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
      });
      if (window && window['moduleType'] && window['moduleType'] == "eap") {
        this.operations.map((columnDef, i) => {
          if (columnDef.name === "Add Fund Request") {
            delete this.operations[i]
          }
        })
      }
    });
  }
  getSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/EAPAllRequests/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.rowData = summary;
    });
  }
  setSummarySearch(searchObject) {
    this.summaryService.fetchSearchData("api/EAPAllRequests/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = summary;
    });
  }


  view(summary, modalserive) {
    //debugger;
    if (this['self'].selectedRow['RequestType'] == "Product") {
      let modalRef = modalserive.show(EapAllRequestsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        ignoreBackdropClick: true,
        class: 'modal-vlg modal-full-height modal-right',
        animated: true,
        data: {
          heading: 'View',
          content: { id: this['self'].selectedRow['ID'] }
        }
      });

    }
  }

  delete(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] < 3) {
      let id = this['self'].selectedRow['ID'];
      this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
      this["self"].modalRef.content.action.subscribe(result => {
        summarySer.DeleteRecord('api/EAPAllRequests/Delete?RecordID=' + id).subscribe(summary => {
          //debugger;
          if (summary["Status"] == 0) {
            this['self'].toastrService.success("Selected Record(s) has been Deleted.");
            this['self'].getSummary();
          }
          else {
            this['self'].toastrService.error("Error Occurred while Deleting the record.Please try again after sometime.");
          }
        });
      })
    }
    else {
      this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  approve(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] == 2) {
      summarySer.getSummaryData("api/EAPAllRequests/Approve?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
        this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
          backdrop: false,
          keyboard: false,
          ignoreBackdropClick: true,
          animated: true,
          data: { heading: 'Approve', content: { heading: '', description: 'The request has been Approved.' } }
        });
        this['self'].getSummary();
      })
    }
    else {
      modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }

  }

  submit(summarySer, modalserive) {
    //debugger;
    if (this['self'].selectedRow['Status'] < 2) {
      summarySer.getSummaryData("api/EAPAllRequests/Submit?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
        this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
          backdrop: false,
          keyboard: false,
          ignoreBackdropClick: true,
          animated: true,
          data: { heading: 'Approve', content: { heading: '', description: 'The request has been Submitted.' } }
        });
        this['self'].getSummary();
      })
    }
    else {
      modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  reject(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] == 2) {

      summarySer.getSummaryData("api/EAPAllRequests/Reject?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
        this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
          backdrop: false,
          keyboard: false,
          ignoreBackdropClick: true,
          animated: true,
          data: { heading: 'Reject', content: { heading: '', description: 'The request has been Rejected.' } }
        });
        this['self'].getSummary();
      })
    }
    else {
      modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }

  }

  withdraw(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] == 2) {
      summarySer.getSummaryData("api/EAPAllRequests/WithDraw?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
        this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
          backdrop: false,
          keyboard: false,
          ignoreBackdropClick: true,
          animated: true,
          data: { heading: 'Withdraw', content: { heading: '', description: 'The request has been withdraw Successfully.' } }
        });
        this['self'].getSummary();
      })
    }
    else {
      modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  close(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] > 3) {
      summarySer.getSummaryData("api/EAPAllRequests/Close?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
        //debugger;
        if (summary != null && summary.Message == "N") {
          if (this['self'].selectedRow['RequestType'] == "Product") {
            modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible Please Adjust Product .' } } });

          }
          else {
            modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible Please Adjust Fund.' } } });
          }
        }
        else {
          this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
            backdrop: false,
            keyboard: false,
            ignoreBackdropClick: true,
            animated: true,
            data: { heading: 'Close', content: { heading: '', description: '’The request has been closed.' } }
          });
          this['self'].getSummary();
        }

      });
    }
    else {
      modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }

  }

  allocate(summarySer, modalserive) {
    //debugger;
    if (this['self'].selectedRow['Status'] == 3) {
      if (this['self'].selectedRow["Allocated"] != null && this['self'].selectedRow["Allocated"] != "" && this['self'].selectedRow["Allocated"] != undefined) {
        summarySer.getSummaryData("api/EAPAllRequests/Allocate?RecordID=" + this['self'].selectedRow["ID"]).subscribe(summary => {
          this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
            backdrop: false,
            keyboard: false,
            ignoreBackdropClick: true,
            animated: true,
            data: {
              heading: 'Allocated',
              content: { heading: '', description: 'The product request has been Allocated.' }
            }
          });
          this['self'].getSummary();
        });
      }
      else {
        if (this['self'].selectedRow['RequestType'] == "Product") {
          let modalRef = this['self'].modalService.show(EapAllRequestsViewModalComponent, {
            backdrop: false,
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-vlg modal-full-height modal-right',
            animated: true,
            data: {
              heading: 'Edit',
              content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID, AllocatedAmount: this["self"].selectedRow["Allocated"] }
            }
          });
          modalRef.content.action.subscribe(result => {
            this['self'].getSummary();
          })
        }
      }
    }
    else {
      modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }


  returnrequest(summarySer, modalserive) {
    if (this['self'].selectedRow['Status'] == 5 || this['self'].selectedRow['Status'] == 6) {
      if (this['self'].selectedRow["returnFund"] != null && this['self'].selectedRow["returnFund"] != "" && this['self'].selectedRow["returnFund"] != undefined) {
          this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
            backdrop: false,
            keyboard: false,
            ignoreBackdropClick: true,
            animated: true,
            data: { heading: 'Allocated', content: { heading: '', description: 'Returns completed successfully.' } }
          });
          this['self'].getSummary();
      }
      else {
        if (this['self'].selectedRow['RequestType'] == "Product") {
          let modalRef = this['self'].modalService.show(EapAllRequestsViewModalComponent, {
            backdrop: false,
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-vlg modal-full-height modal-right',
            animated: true,
            data: {
              heading: 'Edit',
              content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
            }
          });
          modalRef.content.action.subscribe(result => {
            this['self'].getSummary();
          })
        }

      }
    }
    else {
      modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }

  retrieve(summary, modalserive) {
    if (this['self'].selectedRow['Status'] == 5) {
      if (this['self'].selectedRow['RequestType'] == "Product") {
        let modalRef = this['self'].modalService.show(EapReturnRetrivalModalComponent, {
          backdrop: false,
          keyboard: false,
          ignoreBackdropClick: true,
          class: 'modal-md modal-full-height modal-right',
          animated: true,
          data: {
            heading: null,
            content: {
              id: this['self'].selectedRow['ID'],
              ApplicationID: this.ApplicationID,
              Allocated: this["self"].selectedRow["Allocated"],
              ProductUnits: this["self"].selectedRow["ProductUnits"]
            }
          }
        });
        modalRef.content.action.subscribe(result => {
          this['self'].getSummary();
        })
      }


    }
    else {
      modalserive.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: 'Selected operation is not Possible for current Record.' } } });
    }
  }



  bank_account() {
    //let modalRef= this['self'].modalService.show(EapRequestFundBankAccountsModalComponent, {
    //  backdrop: false,
    //  keyboard: false,
    //  ignoreBackdropClick: true,
    //  class: 'modal-llg modal-full-height modal-right',
    //  animated: true,
    //  data: {
    //    heading: 'Add bank',
    //    content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    //  }
    //});
    //modalRef.content.action.subscribe(result => {
    //  this['self'].getSummaryList();
    //});
  }

  update() {
    //this['self'].modalService.show(EapRequestFundUpdateUsageModalComponent, {
    //  backdrop: false,
    //  keyboard: false,
    //  ignoreBackdropClick: true,
    //  class: 'modal-md modal-full-height modal-right',
    //  animated: true,
    //  data: {
    //    heading: 'Update Fund Usage',
    //    content: { id: this.selectedRow['ID'], ApplicationID: this.ApplicationID }
    //  }
    //});
  }




  SearchClear() {
    this.AllRequestSearch.reset();
    //  this.setSummary();
  }
  AdvanceSearch() {
    var formData = this.AllRequestSearch.value;
    //debugger;
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["Status"] != "" && formData["Status"] != undefined && formData["Status"] != null) {
      formData["Status"] = parseInt(formData["Status"]);
    }
    this.setSummarySearch(formData);
  }

}
